import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

import { ApiError, errorMessage } from "@/api/errors";
import { useToast } from "@/components/ui";

/** An expired session is handled by RequireSession (back to sign-in), not by a toast. */
const SESSION_CODES = new Set(["not_authenticated", "authentication_failed"]);

/**
 * Default error toast for failed mutations whose callers don't render the error themselves (see
 * api/mutationMeta.ts for the opt-out). Subscribes to the client's MutationCache, so it needs no global.
 */
export function MutationErrorToasts() {
  const qc = useQueryClient();
  const toast = useToast();
  useEffect(
    () =>
      qc.getMutationCache().subscribe((event) => {
        if (event.type !== "updated" || event.action.type !== "error") return;
        if (event.mutation.meta?.errorToast === false) return;
        const error = event.action.error;
        if (error instanceof ApiError && SESSION_CODES.has(error.code)) return;
        toast(errorMessage(error), { tone: "error" });
      }),
    [qc, toast],
  );
  return null;
}
